export const SHEET_STATE = {
    HALF: 'half',
    FULL: 'full',
};

export const CURRENCY = {
    DA: 'DKK',
};
